import { render, staticRenderFns } from "./popup-notice-dialog.vue?vue&type=template&id=5b06db82&"
import script from "./popup-notice-dialog.vue?vue&type=script&lang=ts&"
export * from "./popup-notice-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./popup-notice-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports